/** Archivage longue durée dossier + actions liste « Demander des documents » */
import { COMMON_UI_I18N_FOLDER_STATUS_MESSAGES } from "./commonUiI18nFolderStatusMessages";

export const COMMON_UI_I18N_PART2_SLICE_F = {
	longTermArchive: {
		title: "Archivage longue durée",
		description:
			"Cette action crée une copie longue durée de tous les documents du dossier dans l’espace d’archivage longue durée.",
		cta: "Démarrer l’archivage",
		inProgress: COMMON_UI_I18N_FOLDER_STATUS_MESSAGES.longTermArchive.inProgress,
		pollHint: COMMON_UI_I18N_FOLDER_STATUS_MESSAGES.longTermArchive.pollHint,
		completed: COMMON_UI_I18N_FOLDER_STATUS_MESSAGES.longTermArchive.completed,
		readOnlyWhilePending: COMMON_UI_I18N_FOLDER_STATUS_MESSAGES.longTermArchive.readOnlyWhilePending,
		readOnlyWhenReady: COMMON_UI_I18N_FOLDER_STATUS_MESSAGES.longTermArchive.readOnlyWhenReady,
		failedPrefix: COMMON_UI_I18N_FOLDER_STATUS_MESSAGES.longTermArchive.failedPrefix,
	},
	documentTypeForm: {
		retentionDaysLabel: "Délai avant expiration (jours)",
		retentionDaysPlaceholder: "Ex. 365",
		defaultRecipientLabel: "Destinataire par défaut des demandes",
		defaultRecipientOptionNone: "Aucun pré-cochage",
		defaultRecipientOptionCustomer: "Client",
		defaultRecipientOptionThirdParty: "Tiers",
		defaultRecipientOptionSharedNotary: "Confrère invité",
		defaultRecipientOptionOfficeNotary: "Notaire de l’étude",
	},
} as const;
